import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TimesheetUtilityService } from '@app/main/time-sheet/services/timesheet-utility.service';
import { AbpSessionService } from 'abp-ng2-module';
import * as _ from 'lodash';
import { DateTime } from 'luxon';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { ActivityServiceProxy, AllDashboardServiceProxy, GetApplicationsDto } from '../../../../../shared/service-proxies/service-proxies';

@Component({
    selector: 'app-dashboard-neutralapps',
    templateUrl: './dashboard-neutralapps.component.html',
    styleUrls: ['./dashboard-neutralapps.component.css']
})
export class DashboardNeutralappsComponent extends AppComponentBase implements OnInit, OnDestroy {
    NeutralAppsDetails: GetApplicationsDto[];
    isLoaded = false;
    isNeutralAppsEmpty = true;
    istrueValue: boolean;
    showNeutralDetails: any;
    constructor(private _AllDashboardServiceProxy: AllDashboardServiceProxy,
        public _tus: TimesheetUtilityService,private _activitesServiceProxy:ActivityServiceProxy,private AbpSession: AbpSessionService,
        private router: Router,
        injector: Injector) { super(injector) }

    ngOnInit(): void {
        this.getNeturalApps();
    }


    async getNeturalApps() {
        this.istrueValue = this.isGranted('Pages.ShowManager.Dashboard');
        let date = new Date();
        await this._AllDashboardServiceProxy.getUserNuetralApplication(false, 1,date.getTimezoneOffset(),'', [], [], [], this.istrueValue, undefined, false,).subscribe(result => {
            this.NeutralAppsDetails = [];
            result = _.orderBy(result, ['applicationSpendTime'], ['desc']);
            result.forEach(x => {
                if (x.applicationSpendTime != undefined || x.applicationSpendTime != null) {
                    this.NeutralAppsDetails.push(x);
                    this.isNeutralAppsEmpty = false;
                }
            });
            this.isLoaded = true;
        })
    }


    stringToDate(e: string) {
        let datetimeapp = e.split(':');
        return datetimeapp[0] + ':' + datetimeapp[1] + ' h';
    }

    viewall() {
        this.router.navigate(['/app/main/activities/time-and-attendance']);
    }
    ngOnDestroy() {
        if (this.showNeutralDetails) {
            clearInterval(this.showNeutralDetails);
        }
    }
    ShowDetails = false;
    LoadingStarted =false;
    HistoryForApp="";
   HistoryDetails=[];
    GetData(appName:string){
        this.HistoryForApp=appName;
        this.ShowDetails =false;
        document.getElementsByClassName('popTemplateClass')[0].className += ' display-none';
        this.LoadingStarted=true;
        this._activitesServiceProxy.getActiveWindowsHistoryForApp(appName,DateTime.fromJSDate(this.setZeroTimeForLocalDate(new Date())),this.AbpSession.userId,this.AbpSession.tenantId).subscribe(res=>{
            this.HistoryDetails = res;
            this.LoadingStarted=false;
            this.HistoryForApp="";
            if(this.HistoryDetails.length>0){
                this.ShowDetails= true;
                let element = document.getElementsByClassName('popTemplateClass');
                for (let i = 0; i < element.length; i++) {
                    element[i].className = element[i].className.replace(/\bdisplay-none\b/, "");
                }
            }
            else{
                this.ShowDetails= false;
                if(document.getElementsByClassName('popTemplateClass')[0]?.className){
                document.getElementsByClassName('popTemplateClass')[0].className += ' display-none';
                }
            }
        });
       
        
    }
    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }

    removeData(){
        this.HistoryForApp="";
        this.LoadingStarted=false;
        this.ShowDetails = false;
        this.HistoryDetails=[];
    }
       
}
